import { useMemo } from 'react';

const shimmerKeyframes = `
@keyframes shimmer {
  0% { background-position: -200px 0; }
  100% { background-position: calc(200px + 100%) 0; }
}
`;

let styleInjected = false;
function injectStyle() {
  if (styleInjected) return;
  const style = document.createElement('style');
  style.textContent = shimmerKeyframes;
  document.head.appendChild(style);
  styleInjected = true;
}

export function Skeleton({ width = '100%', height = '16px', borderRadius = '4px' }) {
  injectStyle();
  return (
    <div
      style={{
        width,
        height,
        borderRadius,
        background: 'linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%)',
        backgroundSize: '200px 100%',
        animation: 'shimmer 1.5s ease-in-out infinite',
      }}
    />
  );
}

export function TableSkeleton({ rows = 8 }) {
  injectStyle();
  const widths = useMemo(() => ['60px', '180px', '120px', '80px', '70px', '40px', '100px', '100px', '80px', '80px', '90px'], []);
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <tr key={i}>
          <td><Skeleton width="16px" height="16px" /></td>
          {widths.map((w, j) => (
            <td key={j}><Skeleton width={w} height="14px" /></td>
          ))}
        </tr>
      ))}
    </>
  );
}
